import { AddEntry } from './components/AddEntry'
import { Container } from './components/Container'
import { EntryList } from './components/EntryList'
import { AppContextProvider } from './contexts/AppContext'

function App() {
  return (
    <AppContextProvider>
      <Container>
        <AddEntry />
        <EntryList />
      </Container>
    </AppContextProvider>
  )
}

export default App
